import React, { useState } from 'react';
import { Box, NavTab, Menu, MenuItem } from 'components';
import { Link, ExternalLink } from 'core/routing';
import * as Icons from './icons';

const FooterMenu = () => {
  const [anchorEl, setAnchor] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isOpen) {
      setAnchor(null);
    } else {
      setAnchor(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchor(null);
  };

  return (
    <>
      <Box sx={{ position: 'absolute', left: 'auto', bottom: 2 }}>
        <NavTab onClick={handleMoreClick} active={isOpen}>
          <Icons.More />
        </NavTab>
      </Box>
      <Menu
        placement='right-bottom'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        sx={{ zIndex: 999999 }}
      >
        <Link name='home.company.about'>
          <MenuItem>
            <Box mr={2}>
              <Icons.Information />
            </Box>
            About Wikifactory
          </MenuItem>
        </Link>
        <ExternalLink to='https://help.wikifactory.com/en/'>
          <MenuItem>
            <Box mr={2}>
              <Icons.HelpCenter />
            </Box>
            Help Center
          </MenuItem>
        </ExternalLink>
        <Link name='home.privacy'>
          <MenuItem>
            <Box mr={2}>
              <Icons.PrivatePolicy />
            </Box>
            Privacy Policy
          </MenuItem>
        </Link>
        <Link name='home.cookies'>
          <MenuItem>
            <Box mr={2}>
              <Icons.Cookies />
            </Box>
            Cookies Policy
          </MenuItem>
        </Link>
        <Link name='home.terms'>
          <MenuItem>
            <Box mr={2}>
              <Icons.TermsConditions />
            </Box>
            Terms & Conditions
          </MenuItem>
        </Link>
      </Menu>
    </>
  );
};

export default FooterMenu;
